import styled from "styled-components";

import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";

export const CardsWrapper = styled(FlexDiv)`
  margin: 0 -8px;
  @media only screen and (max-width: 1079px) {
    margin: 0;
  }
  @media only screen and (max-width: 992px) {
    flex-wrap: wrap;
  }
`;

export const Wrapper = styled(FlexSection)`
  position: relative;
  background-color: ${theme.colorsV2.rose.shade_100};
  padding: 64px 0;
  @media only screen and (max-width: 992px) {
    padding: 40px 0;
  }
`;

export const WrapperContainer = styled(FlexContainer)`
  @media only screen and (max-width: 1079px) {
    padding: 0;
  }
`;

export const PinkBox = styled(FlexDiv)`
  flex-direction: column;
`;

export const CardBox = styled(FlexDiv)`
  width: 100%;
  max-width: 25%;
  margin: 8px;
  background-color: ${theme.colorsV2.rose.shade_25};
  border-radius: 40px;
  padding: 24px;
  @media only screen and (max-width: 1079px) {
    border-radius: 16px;
    padding: 16px;
  }
  @media only screen and (max-width: 992px) {
    max-width: calc(50% - 16px);
    align-items: center;
    text-align: center;
  }
`;

export const ImageBox = styled(FlexDiv)`
  height: 32px;
  width: 32px;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    max-height: 100%;
  }
`;

export const TopBox = styled(FlexDiv)`
  align-items: center;
  padding: 8px 0px;
  @media only screen and (max-width: 992px) {
    flex-direction: column;
    padding: 8px 16px;
  }
`;
